import { Injectable } from "@angular/core";
import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

@Injectable({
  providedIn: "root"
})
export abstract class UtilityService {
  /**
   * Given a URL like "https://agentium.com/" or "https://tools.agentium.com/" returns agentium.com
   */
  public static getNonSubDomainUrlHostName(): string {
    return this.getUrlHostName().split(".").slice(-2).join(".");
  }

  /**
   * Given a URL like "https://agentium.com/" or "https://tools.agentium.com/" returns agentium.com or tools.agentium.com
   */
  public static getUrlHostName(): string {
    return window.location.hostname;
  }

  /**
   * Given a URL like "https://agentium.com/1234/abc" returns "/1234/abc"
   */
  public static getUrlPathName(): string {
    return window.location.pathname;
  }

  /**
   * Given a URL like "https://agentium.com/1234/abc" returns "1234"
   */
  public static getUrlBasePath(): string {
    return this.getUrlPathName().split("/")[1];
  }

  public static isToday(date: Date): boolean {
    if (date == null) {
      return false;
    }
    return new Date().setHours(0, 0, 0, 0) == new Date(date).setHours(0, 0, 0, 0);
  }

  public static timeAgo(dateAdded: Date): string {
    let currentDate: number = Date.now();
    let pastDate: number = new Date(dateAdded).valueOf();
    let duration: number = currentDate - pastDate;

    if (duration > 1000 * 60 * 60 * 24) {
      return `${Math.floor(duration / (1000 * 60 * 60 * 24))} days ago`;
    } else if (duration > 1000 * 60 * 60) {
      return `${Math.floor(duration / (1000 * 60 * 60))} hours ago`;
    } else if (duration > 1000 * 60 * 5) {
      return `${Math.floor(duration / (1000 * 60))} minutes ago`;
    } else {
      return "New";
    }
  }

  public static urlValidator(): ValidatorFn {
    const MAX_LENGTH = 100;

    const urlPattern = new RegExp(
      "^" +
        "(?:https?://)?" +
        "(?:[a-zA-Z0-9\\-]+\\.)+" +
        "(?:[a-zA-Z\\-]{2,63})" +
        "(?:/(?:/|[\\w\\-\\._~:/\\?#\\[\\]@!\\$&'\\(\\)\\*\\+,;=%]*)*)?" +
        "(?:\\?[\\w\\-\\._~:/\\?#\\[\\]@!\\$&'\\(\\)\\*\\+,;=%]+=[\\w\\-\\._~:/\\?#\\[\\]@!\\$&'\\(\\)\\*\\+,;=%]*(?:&[\\w\\-\\._~:/\\?#\\[\\]@!\\$&'\\(\\)\\*\\+,;=%]+=[\\w\\-\\._~:/\\?#\\[\\]@!\\$&'\\(\\)\\*\\+,;=%]*)*)?" +
        "$"
    );

    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value?.trim();
      if (!value) {
        return null;
      }

      if (value.length > MAX_LENGTH) {
        return { urlTooLong: true };
      }

      if (!urlPattern.test(value)) {
        return { invalidUrl: true };
      }

      return null;
    };
  }
}
